import { AfterViewInit, Directive, ElementRef, Input, OnInit } from '@angular/core';

/**
 * Directive for focus the input text and select all the text if autoselection is true
 */
@Directive({
    selector: '[cwAutoFocus]',
    standalone: false,
})
export class AutoFocusDirective implements OnInit, AfterViewInit {
    /** Selects all the text in the html element */
    @Input() autoSelection = false;
    /** Delay to set the autofocus. By default is zero */
    @Input() autoFocusDelay = 0;

    constructor(private elementRef: ElementRef) {}

    ngOnInit(): void {
        setTimeout(() => {
            this.elementRef.nativeElement.focus();
        }, this.autoFocusDelay);
    }

    ngAfterViewInit(): void {
        if (this.autoSelection) {
            setTimeout(() => {
                this.elementRef.nativeElement.select();
            }, this.autoFocusDelay);
        }
    }
}
